export default "__VITE_ASSET__Dxala0ER__"